const enGB = {
    'global': {
        'default': {
            'refresh': 'Refresh',
            'all': 'All',
            'back': 'Back',
            'edit': 'Edit',
            'delete': 'Delete',
            'cancel': 'Cancel',
            'save': 'Save',
        },
    },
    'TopdataContactLoginSW6': {
        'regLog': {
            'module': {
                'name': 'Registration Attempt Logs',
                'title': 'Registration Attempt Logs',
                'description': 'View logs of failed registration and checkout attempts due to duplicate emails',
            },
            'list': {
                'title': 'Registration Attempt Logs',
                'buttonDownloadCsv': 'Download CSV',
                'exportError': 'Failed to export CSV',
                'buttonClear': 'Clear',
                'clearModalTitle': 'Clear registration log',
                'clearModalBody': 'Are you sure you want to delete all registration log entries? This action cannot be undone.',
                'clearModalConfirm': 'Yes, clear all',
                'clearSuccess': 'Registration log has been cleared',
                'clearError': 'Failed to clear registration log',
                'filter': {
                    'attemptType': 'Attempt Type',
                    'conflictType': 'Conflict Type',
                },
                'searchEmailPlaceholder': 'Search by email address…',
                'column': {
                    'email': 'Email',
                    'attemptType': 'Attempt Type',
                    'conflictType': 'Conflict Type',
                    'createdAt': 'Date',
                },
            },
            'detail': {
                'title': 'Registration Attempt Log',
                'card': {
                    'logInfo': 'Attempt Details',
                    'customerInfo': 'Customer Information',
                },
                'label': {
                    'email': 'Email Address',
                    'attemptType': 'Attempt Type',
                    'conflictType': 'Conflict Type',
                    'createdAt': 'Date',
                    'ipAddress': 'IP Address',
                    'userAgent': 'User Agent',
                    'customerName': 'Customer Name',
                    'customerEmail': 'Customer Email',
                },
                'notFound': 'Log entry not found',
            },
            'attemptType': {
                'guest_checkout': 'Guest Checkout',
                'registration': 'Registration',
                'contact_create': 'Contact Creation',
                'contact_email_change': 'Contact Email Change',
            },
            'conflictType': {
                'customer_exists': 'Customer Exists',
                'contact_exists': 'Contact Exists',
            },
        },
    },
};

export default enGB;
